"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpdUserService = void 0;
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const request_1 = require("../common/request");
class TpdUserService {
}
exports.TpdUserService = TpdUserService;
_a = TpdUserService;
TpdUserService.notifiche = {
    endPoint: "notifiche-push/v1/notifiche",
    elencoNotifiche: ({ soloConteggio, IdTopics }) => {
        const commonNetworkService = new nodejs_library_1.CommonNetworkService();
        const querys = {
            IdTopics,
            soloConteggio: soloConteggio ? soloConteggio : "false",
            tipo: "comunicazioni",
        };
        const headers = {
            "x-unipol-canale": "AR",
        };
        const request = new request_1.Request(_a.notifiche.endPoint, {
            queryParams: querys,
            headers,
        });
        return commonNetworkService.get(request.completeUrl, request.headers);
    },
    leggiNotifiche: (elencoNotificheDaLeggere) => {
        const commonNetworkService = new nodejs_library_1.CommonNetworkService();
        const body = elencoNotificheDaLeggere;
        const headers = {
            "x-unipol-canale": "AR",
        };
        const request = new request_1.Request(_a.notifiche.endPoint + "/stato", {
            body,
            headers,
        });
        return commonNetworkService.put(request.completeUrl, request.body, request.headers);
    },
};
